// patchMeData.js
'use strict';
import 'isomorphic-fetch';
import { getHeaders } from '../resource/fetchOptionHeader.js';
import getResourceUrl from '../resource/getResourceUrl.js';
import handleFetchError from '../resource/handleFetchError.js';
import getMeData from '../selector/getMeData.js';
import {
  MERGE_ME_DATA,
  MERGE_OPERATION_DATA,
  SET_NETWORKING_FETCHING,
  SET_NETWORKING_SUCCESS,
  SET_NETWORKING_ERROR,
} from '../ActionTypes.js';

const selectPath = ['patch', 'me'];

/**
 * Patch me data
 * @kind action
 * @param {object} {data} - new me data.
 * @return {Promise} Action promise.
 */
const patchMeData =
  ({ data }) =>
  async (dispatch, getState) => {
    const token = getMeData(getState(), 'token');
    if (!token) {
      return dispatch({ type: '' });
    }
    dispatch({ type: SET_NETWORKING_FETCHING, payload: { selectPath } });

    const url = getResourceUrl({ endpoint: '/me' });
    const fetchOptions = {
      method: 'PATCH',
      headers: {
        ...getHeaders(),
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    };

    let response;
    try {
      response = await fetch(url.href, fetchOptions);

      if (204 !== response.status) {
        response = await handleFetchError({
          response,
          dispatch,
          getState,
          fetchOptions,
          fetchUrl: url,
        });
      }

      dispatch({ type: SET_NETWORKING_SUCCESS, payload: { selectPath } });
      const stateData = Object.keys(data).reduce((current, key) => {
        const value = data[key];
        if (value instanceof File) {
          current[key] = URL.createObjectURL(value);
        } else {
          current[key] = value;
        }
        return current;
      }, {});
      return dispatch({ type: MERGE_ME_DATA, payload: stateData });
    } catch (error) {
      let errorObject = {};
      try {
        errorObject = JSON.parse(error.message);
        // eslint-disable-next-line no-empty
      } catch (e) {}
      if ('displayName' in data) {
        const errorMessageSelectPath = ['displayName', 'errorMessage'];
        if ('alert_over_the_rate_limit' === errorObject.code) {
          dispatch({
            type: MERGE_OPERATION_DATA,
            payload: {
              selectPath: errorMessageSelectPath,
              data: {
                availableUpdateTime: parseInt(
                  response?.headers?.get('X-RateLimit-Reset') || 0,
                  10
                ),
              },
            },
          });
        } else if ('PAYLOAD_VALIDATION_ERROR' === errorObject.code) {
          dispatch({
            type: MERGE_OPERATION_DATA,
            payload: {
              selectPath: errorMessageSelectPath,
              data: {
                errorMessageI18nKey: 'display_name_invalid',
              },
            },
          });
        }
      }
      return dispatch({
        type: SET_NETWORKING_ERROR,
        payload: { selectPath, error },
      });
    }
  };

export default patchMeData;
